Ext.define('SA.model.PointPackageDowngradedNotice', {
    statics: {
        deserialize(notices) {
            var ids = notices.map(({user_notification_id: id}) => id),
                packageNames = notices.map(({message}) => message);

            return new SA.model.PointPackageDowngradedNotice(ids, packageNames);
        }
    },

    constructor(ids, packageNames) {
        this.ids = ids;
        this.packageNames = packageNames;
    },

    getPackageNames() {
        return this.packageNames;
    },

    markViewed() {
        SA.model.Notices.acknowledge({ids: this.ids});
    }
});